export enum DocumentItemKeyType {
    Customer = 1,
    Vehicle = 2,
    VehicleOwnership = 3,
    Title = 4,
    Registration = 5,
    VehiclePermit = 6,
    BusinessTransactionNumber = 7,
    DriverCredentialID = 8,
    Case = 9,
    ProhibitionCompliance = 10,
    PlacardID = 11,
    FinanceDisbursementRequest = 12,
    FuelTaxCompliance = 23,
    FinanceJournalEntry = 24,
    ATPCompany = 29,
    ATPBond = 30,
    ATPInsurance = 31,
    ATPAgreement = 32,
    ATPInspection = 33,
    OIGIncidentReport = 34,
    ATPCompanyEmployee = 35
}
